export enum EnPaperOrientation {
    Portrait = 'portrait',
    Landscape = 'landscape'
}
